import Vue from 'vue';

// axios
import axios from 'axios';

const axiosIns = axios.create({
    // Use relative base URL for proxy routing
    baseURL: '/api',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor for debugging (optional)
axiosIns.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor for debugging (optional)
axiosIns.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
